




























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// Not sure if this is needed yet?
import { mixins } from 'vue-class-component';
import QueryEndpointData from './dataquery-mixin';

import MetricsHistogram from './MetricsHistogram.vue';

@Component({
    components: {
        MetricsHistogram
    }
})
export default class Metrics extends mixins(QueryEndpointData) {
    @Prop() metric_type?: 'supply_chain_leg_cat' | 'total' | 'hist_supply_chain' | 'hist_total' | null;
    @Prop() map_id!: string;
    @Prop() histogram!: boolean;

    selectedMetric: any = null;

    metrics = {
        distance_metric: {
            value: 'od_km',
            title: {
                total: 'Total Trip Distance',
                supply_chain_leg_cat: 'Avg Trip Distance',
            },
            description: {
                total: 'Weighted sum of trip distances (km) travelled by the commodity from its point of production or import to point of retail or export.',
                supply_chain_leg_cat: 'Weighted average of the trip distance (km) travelled for each movement in the supply chain leg category.',
            },

        },
        duration_metric: {
            value: 'od_hour',
            title: {
                total: 'Total Trip Duration',
                supply_chain_leg_cat: 'Avg Trip Duration',
            },
            description: {
                total: 'Weighted sum of trip durations (hrs) taken for the transportation of a commodity from its point of production or import to its point of retail or export.',
                supply_chain_leg_cat: 'Weighted average of the trip duration (hrs) taken for each movement in the supply chain leg category.',
            },
        },
        cost_metric: {
            value: 'cost_per_tonne',
            title: {
                total: 'Total Transport Costs/tn',
                supply_chain_leg_cat: 'Avg Transport Costs/tn',
            },
            description: {
                total: 'Weighted sum of trip costs ($) per tonne of freight for the transportation of a commodity from its point of production or import to its point of retail or export.',
                supply_chain_leg_cat: 'Weighted average of the trip costs ($) per tonne of freight for each movement in the supply chain leg category.',
            },
        },
        co2_metric: {
            value: 'co2_per_tonne',
            title: {
                total: 'Total CO<sub>2</sub> Emissions/tn',
                supply_chain_leg_cat: 'Avg CO<sub>2</sub> Emissions/tn',
            },
            description: {
                total: 'Weighted sum of trip CO2 (tn) per tonne of freight produced in the transportation of a commodity from its point of production or import to its point of retail or export.',
                supply_chain_leg_cat: 'Weighted average of the trip CO2 (tn) per tonne of freight for each movement in the supply chain leg category.',
            },
        },
        crossings_metric: {
            value: 'state_territory_border_crossings',
            title: {
                total: 'Total State & Territory border crossings',
            },
            description: {
                total: 'Weighted sum of the number of trip State/Territory border crossings involved in the transportation of a commodity from its point of production or import to its point of retail or export.',
            },
        }
    } as const;


    get metricsUrl() {
        return process.env.VUE_APP_BACKEND_BASE + "/supplychainexplorer/metrics";
    }

    mounted() {
        this.loadData(this.metricsUrl);
    }

    @Watch('updateRequired')
    reloadData(newVal: any, oldVal: any) {
        this.loadData(this.metricsUrl);
    }

    metric_values() {
        return this.data.find((d: any) => d.supply_chain_leg_cat === this.map_id);
    }

    get trip_distance() {
        if (this.metric_type === 'total') {
            var entry = this.data?.find((row: any) => row.index === this.metrics.distance_metric.value); // this will be cleaner once sce backend func returns properly formated outputs
            return this.numberWithCommas(entry?.['0']?.toFixed(1) || '0');
        } else {
            var entry = this.metric_values();
            return this.numberWithCommas((entry?.[this.metrics.distance_metric.value] as number)?.toFixed(1) || '0');
        }
    }

    get trip_duration() {
        if (this.metric_type === 'total') {
            var entry = this.data?.find((row: any) => row.index === this.metrics.duration_metric.value);
            return this.numberWithCommas(entry?.['0']?.toFixed(1) || '0');
        } else {
            var entry = this.metric_values();
            return this.numberWithCommas((entry?.[this.metrics.duration_metric.value] as number)?.toFixed(1) || '0');
        }
    }

    get transport_costs() {
        if (this.metric_type === 'total') {
            var entry = this.data?.find((row: any) => row.index === this.metrics.cost_metric.value);
            return this.numberWithCommas(entry?.['0']?.toFixed(1) || '0');
        } else {
            var entry = this.metric_values();
            return this.numberWithCommas((entry?.[this.metrics.cost_metric.value] as number)?.toFixed(1) || '0');
        }
    }

    get co2_tn() {
        if (this.metric_type === 'total') {
            var entry = this.data?.find((row: any) => row.index === this.metrics.co2_metric.value);
            return this.numberWithCommas(entry?.['0']?.toFixed(2) || '0');
        } else {
            var entry = this.metric_values();
            return this.numberWithCommas((entry?.[this.metrics.co2_metric.value] as number)?.toFixed(2) || '0');
        }
    }

    get border_crossings_metric() {
        var entry = this.data?.find((row: any) => row.index === this.metrics.crossings_metric.value);
        return entry ? entry['0'].toFixed(1) ?? 0 : 0;
    }

    showMetricsHistogram(metricKey: string, title: string) {
        this.selectedMetric = title;
        this.$emit('metric-clicked', metricKey, title);
    }
    
}


